import { Container, Graphics, Sprite, Texture } from "pixi.js";

/** Dust motes drifting in the light shafts (HD-2D sparkle). Points live in world pixels. */
export class Dust {
  layer = new Container();
  private motes: { s: Sprite; x: number; y: number; vx: number; vy: number; ph: number; poly: number }[] = [];
  private polys: [number, number][][] = [];
  private static tex: Texture | null = null;

  constructor(private count = 70) {
    this.layer.blendMode = "add";
  }

  setShafts(polys: [number, number][][], renderer: { generateTexture: (g: Graphics) => Texture }) {
    this.polys = polys.filter((p) => p.length >= 3);
    if (!Dust.tex) {
      const g = new Graphics().rect(0, 0, 1, 1).fill({ color: 0xfff0d0 });
      Dust.tex = renderer.generateTexture(g);
      Dust.tex.source.scaleMode = "nearest";
    }
    for (const m of this.motes) m.s.destroy();
    this.motes = [];
    if (!this.polys.length) return;
    for (let i = 0; i < this.count; i++) {
      const poly = i % this.polys.length;
      const p = this.randomIn(poly);
      const s = new Sprite(Dust.tex!);
      s.blendMode = "add";
      this.layer.addChild(s);
      this.motes.push({ s, x: p[0], y: p[1], vx: (Math.random() - 0.5) * 2, vy: 1 + Math.random() * 2, ph: Math.random() * 6.28, poly });
    }
  }

  private randomIn(i: number): [number, number] {
    const poly = this.polys[i];
    const xs = poly.map((p) => p[0]);
    const ys = poly.map((p) => p[1]);
    for (let k = 0; k < 30; k++) {
      const x = Math.min(...xs) + Math.random() * (Math.max(...xs) - Math.min(...xs));
      const y = Math.min(...ys) + Math.random() * (Math.max(...ys) - Math.min(...ys));
      if (inside(poly, x, y)) return [x, y];
    }
    return [poly[0][0], poly[0][1]];
  }

  tick(dt: number, t: number) {
    for (const m of this.motes) {
      m.x += m.vx * dt;
      m.y += m.vy * dt;
      if (!inside(this.polys[m.poly], m.x, m.y)) [m.x, m.y] = this.randomIn(m.poly);
      m.s.position.set(Math.round(m.x), Math.round(m.y));
      m.s.alpha = 0.35 + 0.35 * Math.sin(t * 1.7 + m.ph);
    }
  }
}

function inside(poly: [number, number][], x: number, y: number): boolean {
  let c = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const [xi, yi] = poly[i];
    const [xj, yj] = poly[j];
    if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) c = !c;
  }
  return c;
}
